<script setup lang="ts">
import PopularityFeatures from '@/pages/forLaywers/ui/PopularitySection/PopularityFeatures.vue';
import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <section :class="['popularity', { _mobile: isMobile }]">
    <div class="popularity__inner">
      <div class="popularity__item">
        <h2 class="popularity__title">
          Попробуйте новые инструменты привлечения клиентов<br />
        </h2>
      </div>
      <div class="popularity__item">
        <div class="popularity__item-content _first">
          <div class="popularity__item-text">
            Разместите свой профиль в
            <NuxtLink class="popularity__item-link" :to="ROOT_CATALOG_URL">
              каталоге
            </NuxtLink>
          </div>
        </div>
        <div class="popularity__item-content _second">
          <div class="popularity__item-text">Отвечайте на заявки в личном чате</div>
        </div>
        <div class="popularity__item-content _third">
          <div class="popularity__item-text">Откройте запись для новых клиентов</div>
        </div>
      </div>
    </div>
    <div class="popularity__features">
      <PopularityFeatures />
    </div>
  </section>
</template>

<style lang="less">
.popularity {
  position: relative;

  &__inner {
    .container-d();

    display: flex;
    align-items: center;
    padding-top: 122px;
    padding-bottom: 281px;
  }

  &__item {
    width: 100%;
  }

  &__title {
    .title-section();

    max-width: 385px;

    @media @tablet {
      font-size: 47px;
      line-height: 65px;
      max-width: 355px;
    }
  }

  &__item-content {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 53px;
    }

    &::before {
      content: '';
      display: block;
      max-width: 100%;
      height: auto;
      min-width: 217px;
      min-height: 92px;
      background-size: 217px 92px;

      @media @tablet {
        min-width: 190px;
        min-height: 75px;
        background-size: 190px 75px;
      }
    }

    &._first::before {
      background-image: url('/images/lawyers-page/popularity-number-1.svg');
    }

    &._second::before {
      background-image: url('/images/lawyers-page/popularity-number-2.svg');
    }

    &._third::before {
      background-image: url('/images/lawyers-page/popularity-number-3.svg');
    }
  }

  &__item-text {
    font-size: @size-x6;
    line-height: 25px;
    font-weight: 600;
    position: relative;
    margin-left: 51px;

    @media @tablet {
      margin-left: @size-x6;
    }
  }

  &__item-link {
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: @color-persimmon;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;

    &:hover {
      text-decoration: none;
    }
  }

  &__features {
    position: absolute;
    top: calc(100% - 160px);
    width: calc(100% - 240px);
    max-width: 1200px;
    left: 50%;
    transform: translateX(-50%);
  }

  &._mobile &__inner {
    .container-m();

    flex-wrap: wrap;
    padding-top: 55px;
    padding-bottom: 64px;
  }

  &._mobile &__title {
    font-size: @size-x6;
    line-height: 25px;
    text-align: center;
    max-width: 100%;
    margin-bottom: 41px;
  }

  &._mobile &__item-content {
    &:not(:last-child) {
      margin-bottom: 56px;
    }

    &::before {
      min-width: 136px;
      min-height: 54px;
      background-size: 136px 54px;
    }
  }

  &._mobile &__item-text {
    font-size: @size-x4;
    line-height: 22px;
    font-weight: 700;
    margin-left: @size-x3;
  }

  &._mobile &__features {
    background-color: @color-black-haze;
    position: relative;
    width: 100%;
    max-width: 100%;
  }
}
</style>
